import { render, staticRenderFns } from "./AccidentPdfFileWidget.vue?vue&type=template&id=15eed2a3&scoped=true&"
import script from "./AccidentPdfFileWidget.vue?vue&type=script&lang=js&"
export * from "./AccidentPdfFileWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccidentPdfFileWidget.vue?vue&type=style&index=0&id=15eed2a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eed2a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15eed2a3')) {
      api.createRecord('15eed2a3', component.options)
    } else {
      api.reload('15eed2a3', component.options)
    }
    module.hot.accept("./AccidentPdfFileWidget.vue?vue&type=template&id=15eed2a3&scoped=true&", function () {
      api.rerender('15eed2a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AccidentPdfFileWidget.vue"
export default component.exports